import { useEffect, useState } from "react";
import { stickyAddress, statusMeta } from "@/mocks/home";

const navItems = [
  { href: "#channels", label: "入口通道" },
  { href: "#updates", label: "更新动态" },
  { href: "#collections", label: "合集索引" },
  { href: "#guide", label: "防走丢" },
  { href: "#faq", label: "常见问题" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = window.setTimeout(() => setCopied(false), 1800);
    return () => window.clearTimeout(timer);
  }, [copied]);

  const copyAddress = async () => {
    try {
      await navigator.clipboard.writeText(stickyAddress.host);
    } catch {
      // clipboard may be unavailable; feedback is still shown
    }
    setCopied(true);
  };

  return (
    <header className="sticky top-0 z-40 border-b border-background-200/80 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-[68px] max-w-shell items-center justify-between gap-4 px-4 md:h-[74px] md:px-6">
        <a href="#top" className="flex shrink-0 items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-article-line text-xl" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-[22px]">
              黑料总站
            </span>
            <span className="mt-1 font-label text-[10px] tracking-[0.32em] text-foreground-500">
              PUBLISHING PAGE
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap font-label text-sm text-foreground-700 transition-colors hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={copyAddress}
            className="hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600 sm:flex"
          >
            <i className={copied ? "ri-check-line text-base" : "ri-file-copy-line text-base"} />
            {copied ? "已复制永久地址" : "复制永久地址"}
          </button>

          <button
            type="button"
            aria-label="展开导航"
            onClick={() => setOpen((prev) => !prev)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <div className="mx-auto flex max-w-shell flex-col px-4 py-3 md:px-6">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="border-b border-background-200/70 py-3 font-label text-sm text-foreground-700 last:border-b-0"
              >
                {item.label}
              </a>
            ))}
            <div className="mt-3 flex items-center gap-2 font-label text-xs text-foreground-500">
              <i className="ri-shield-check-line text-base text-primary-600" />
              {statusMeta.totalChannels}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}